module.exports = __webpack_public_path__ + "img/safie.d4e73fcd.png";